import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-trophy",
  templateUrl: "./med-icon-trophy.component.html",
})
export class MedIconTrophyComponent extends SvgMixinComponent {}
